import { OrgAvatar } from './Avatar';
import { cn } from './cn';
import { isNotEmpty } from './common';

export interface ContactCardOrgRowOrg {
  id: string;
  name: string | null;
  pictureUrl: string | null;
}

type ContactCardOrgRowPureProps = {
  title?: string;
  orgName?: string | null;
  orgPictureUrl?: string | null;
  size?: 'default' | 'pipeline';
};

export default function ContactCardOrgRowPure({ orgName, orgPictureUrl, title, size = 'default' }: ContactCardOrgRowPureProps) {
  const avatarSizeClass = size === 'pipeline' ? 'size-3.5' : 'size-5';

  return (
    <div className={cn('flex gap-1.5 text-slate-700 dark:text-slate-300', size === 'pipeline' && 'gap-1')}>
      <OrgAvatar name={orgName} src={orgPictureUrl} className={avatarSizeClass} />
      <div className={cn('min-w-0 flex-1 truncate text-xs font-lightnormal', size === 'pipeline' && 'text-2xs')}>
        {isNotEmpty(orgName) && <strong className="font-medium">{orgName} </strong>}
        {title && <span>{title}</span>}
      </div>
    </div>
  );
}
